import React, { useState, useEffect} from "react";
import {collection, getDocs, addDoc, doc} from "firebase/firestore";
import {db} from "../firebase/firebaseConfig2";
import {redirect, useNavigate,withRouter} from "react-router-dom";


export default function Reg(){
    const [newFirstName, setNewFirstName] = useState("")
    const [newLastName, setNewLastName] = useState("")
    const [newEmail, setNewEmail] = useState("")
    const [newAffiliation, setNewAffiliation] = useState("")
    const [newRefferal, setNewRefferal] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [redirect, setRedirect] = useState(false)
    let isJermaineOk
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const usersRef = collection(db,"users")
   const createUser = async () =>{
        await addDoc(usersRef, {
            firstName: newFirstName,
            lastName: newLastName,
            email: newEmail,
            affiliation: newAffiliation,
            refferal: newRefferal,
            password: newPassword
        })
    }

    useEffect(() => {
        const getUsers = async () => {
            const data = await getDocs(usersRef)
            setUsers(data.docs.map(docs => ({...docs.data(), id: docs.id})))
        }

        getUsers()
    }, [usersRef])



    let onHandleSubmit = (event) => {
        event.preventDefault();
        checkLiab();
    }
    let checkLiab = () =>{
        if(document.getElementById("liability").checked !== true ){
            alert("Please acknowledge that you have read and understood the liability release agreement for PQE-2023. ")
        }
        else{
            if( window.confirm(`
                Thank you ${newFirstName} for registering! \n 
                Please confirm the information below: \n 
                Name: \u00a0 ${newFirstName} ${newLastName}  \n
                Email:\u00a0 ${newEmail} \n
                Affiliation:\u00a0 ${newAffiliation} \n
                Refferal:\u00a0 ${newRefferal} \n
                
            `) === true){
                createUser();
                setNewFirstName("")
                setNewLastName("")
                setNewEmail("")
                setNewAffiliation("")
                setNewRefferal("")
                setNewPassword("")
                setRedirect(true)
                navigate('/confirm')


            }
        }

    }


    return(
        <div>


            <h1 className={"About-Header"}>Registration</h1>
            <form  className={'regForm'} onSubmit={onHandleSubmit}>
            <label className={"Reg-Label"}>
                First Name:
                <br/>
                <input  className={"Reg-Input"} required  placeholder={"First Name"} value={newFirstName} onChange={(event) => setNewFirstName(event.target.value) } />
            </label>
            <br/>
            <label className={"Reg-Label"}>
                Last Name:
                <br/>
                <input  className={"Reg-Input"} required placeholder={"Last Name"} value={newLastName} onChange={(event) => setNewLastName(event.target.value) } />
            </label>
            <br/>
            <label className={"Reg-Label"}>
                Email:
                <br/>
                <input  className={"Reg-Input"} required placeholder={"Email"}  value={newEmail} onChange={(event) => setNewEmail(event.target.value) } />
            </label>
            <br/>
            <label className={"Reg-Label"}>
                Affiliation:
                <br/>
                <input className={"Reg-Input"} required  placeholder={"Affiliation"} value={newAffiliation} onChange={(event) => setNewAffiliation(event.target.value) } />
            </label>
            <br/>
            <label className={"Reg-Label"}>
                Who Invited you?:
                <br/>
                <input  className={"Reg-Input"} required placeholder={"Refferal"} value={newRefferal} onChange={(event) => setNewRefferal(event.target.value) } />
            </label>
            <br/>
            <label className={"Reg-Label"}>
                Password:
                <br/>
                <input type={"password"} required className={"Reg-Input"} placeholder={"Password"} value={newPassword} onChange={(event) => setNewPassword(event.target.value) } />

            </label>
            <br/>
            <label className={"Reg-Label"}>
                <input type="checkbox" id={'liability'} className={"Reg-Input"}/> I acknowledge
                that I have read and understand the Liability Release Agreement for PQE-2023.
            </label>
            <br/>

            <button className={"Reg-Button"} type={"submit"}>Register</button>

        </form>


        </div>
    )
}